import { Divider, FormLabel, Typography, useTheme } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import Grid2 from '@thirdparty-framework/mui/material/Grid';
import { formatUSPhoneNumber } from '@product-framework/components/FormFields/PhoneNumber';
import { useLocalization, useMasterData } from '@ui-framework/index';
import PermissionButton from '@product-framework/components/PermissionButton';
import InfoBlock from './InfoBlock';
import FormLabelCustom from './FormLabel';
import DistanceFromCustomer from './DistanceFromCustomer';

function ServiceProviderInfo({ serviceProvider, currentJob, setDialog }) {
  const theme = useTheme();
  const { sp, spAddress } = serviceProvider;
  const { formatMessage } = useLocalization();

  const spContact = sp?.contacts?.find(
    c => c.locationId === spAddress.locationId,
  );

  const { pendingServiceJobStatus } = useMasterData();
  const assign = pendingServiceJobStatus.includes(currentJob?.serviceJobStatus);

  const activeServiceProvider = sp?.status === 'ACTIVE';

  return (
    <Grid2 sx={{ padding: '5px 10px 10px 10px', minWidth: '300px' }}>
      <Grid2 sx={{ marginBottom: '0px' }}>
        <FormLabel sx={{ mb: 0, p: 0, color: theme.palette.primary.main }}>
          <FormattedMessage
            id="SERVICE_PROVIDER"
            defaultMessage="Service Provider"
          />
        </FormLabel>
        <Typography sx={{ fontSize: '18px', fontWeight: 500, mt: -0.9, mb: 1 }}>
          {sp.name}
        </Typography>
      </Grid2>
      <Grid2>
        <InfoBlock
          label={formatMessage({
            id: 'LEGEND_SERVICES_BRAND',
            defaultMessage: 'Services Brand',
          })}
          value={sp?.servicesBrand ? 'Yes' : 'No'}
        />
        <InfoBlock
          label={formatMessage({
            id: 'LEGEND_SERVICES_INDUSTRY',
            defaultMessage: 'Services Industry',
          })}
          value={sp?.servicesIndustry ? 'Yes' : 'No'}
        />
        <InfoBlock
          label={formatMessage({
            id: 'LEGEND_PREVIOUSLY_REJECTED',
            defaultMessage: 'Previously Rejected',
          })}
          value={sp?.dispatchEvent?.status === 'REJECTED' ? 'Yes' : 'No'}
        />
        <InfoBlock
          label={formatMessage({
            id: 'LEGEND_SERVICES_PRODUCT_LINE',
            defaultMessage: 'Services Product Line',
          })}
          value={sp?.servicesProductLine ? 'Yes' : 'No'}
        />
      </Grid2>
      <Divider sx={{ marginTop: '5px', marginBottom: '5px' }} />
      <Grid2 sx={{ marginBottom: '10px' }}>
        <FormLabel component="span">
          <FormattedMessage
            id="DISTANCE_FROM_CUSTOMER"
            defaultMessage="Distance from customer: "
          />
        </FormLabel>
        <DistanceFromCustomer
          jobLocation={{
            lat: currentJob?.locationLat,
            lng: currentJob?.locationLng,
          }}
          serviceProviderAddressLocation={{
            lat: spAddress?.locationLat,
            lng: spAddress?.locationLng,
          }}
        />
      </Grid2>
      <Grid2 sx={{ marginBottom: '5px' }}>
        <FormLabel>
          <FormattedMessage id="CONTACT_INFO" defaultMessage="Contact Info" />
        </FormLabel>
      </Grid2>
      <Grid2>
        <FormLabelCustom>{sp?.name || 'Name not available'}</FormLabelCustom>
        <FormLabelCustom>
          {spContact?.user?.email || 'Email not available'}
        </FormLabelCustom>
        <FormLabelCustom>
          {spContact?.user?.phoneNumber
            ? formatUSPhoneNumber(spContact?.user?.phoneNumber)
            : 'Phone not available'}
        </FormLabelCustom>
      </Grid2>
      <Divider sx={{ marginTop: '5px', marginBottom: '5px' }} />
      <Grid2
        container
        justifyContent="space-between"
        alignItems="center"
        sx={{ mt: 1 }}>
        {activeServiceProvider ? (
          <PermissionButton
            permissionName="CAN_UPDATE_JOB_FROM_MAP"
            sx={{ textTransform: 'none' }}
            variant="outlined"
            size="small"
            onClick={() => setDialog('MESSAGE')}>
            <FormattedMessage id="SEND_MESSAGE" defaultMessage="Send Message" />
          </PermissionButton>
        ) : (
          <>&nbsp;</>
        )}
        <PermissionButton
          permissionName="CAN_UPDATE_JOB_FROM_MAP"
          size="small"
          variant="contained"
          disabled={sp?.id === currentJob?.serviceProviderId || !assign}
          onClick={() => setDialog('ASSIGN')}>
          {sp?.id === currentJob?.serviceProviderId ||
          !currentJob?.serviceProviderId ? (
            <FormattedMessage id="BUTTON_ASSIGN" defaultMessage="Assign" />
          ) : (
            <FormattedMessage id="BUTTON_REASSIGN" defaultMessage="Reassign" />
          )}
        </PermissionButton>
      </Grid2>
    </Grid2>
  );
}

export default ServiceProviderInfo;
